import * as React from "react";
import ForCompaniesFaq from "./ForCompaniesFaq";
import ForIdividuals from "./ForIndividuals";

import CantFindAnswer from "../../global/cant-find-answers/CantFindAnswer";
import "./Faq.css";

export default function SimpleAccordions() {
  return (
    <>
      <section id="faq">
        <div className="container">
          <div className="row-essy">
            <div className="col-essy-lg-4 col-essy-md-4">
              <div className="faq-heading">
                <h1>Frequently Asked Questions</h1>
              </div>
            </div>
            <div className="col-essy-lg-8 col-essy-md-8">
              <div className="faq-heading-wrapper">
                <ForCompaniesFaq />
                <ForIdividuals />
              </div>
            </div>
          </div>
        </div>
      </section>
      <CantFindAnswer />
    </>
  );
}
